import { Component, HostListener, Inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { DataService } from '../../Services/data.service';
import { DialogService } from '../../Services/dialog.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { Comments, CommentsComponent } from '../comments/comments.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FileDetails, FilesComponent } from '../files/files.component';
import { MatMenuModule } from '@angular/material/menu';
import { OptionsDialogComponent } from '../dialogs/options-dialog/options-dialog.component';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { MyBoolean, OrderDetailsNew } from '../../models/order.models';
import { FilesDialogComponent } from '../files-dialog/files-dialog.component';
import { finalize } from 'rxjs/operators';
import { UploadState, FileProgress, Task } from '../../models/task.models';



@Component({
  selector: 'app-in-progress',
  standalone: true,
  imports: [MatPaginatorModule, CommonModule, MatSelectModule, MatCardModule, FormsModule, MatFormFieldModule, MatInputModule, DatePipe, MatCheckboxModule, MatIconModule, MatButtonModule, MatBadgeModule, MatMenuModule, MatTooltipModule, MatDialogModule],
  templateUrl: './task-list.component.html',
  styleUrl: './task-list.component.css'
})
export class TaskListComponent {

  @Input() fileDetailsImagesContent!: string[]
  @Input() orderDetailsNew!: OrderDetailsNew;

  // utils/time-left.ts

  selectedPerson: string | null = null;
  selectedOptions: string[] = [];
  filterTriggerValue: string | null = null;

  downloadandSearch: boolean = true;
  feedbackText = ''

  downloadScanFiles() {
    throw new Error('Method not implemented.');
  }
  selectedDesigner: any;
  selectedDoctor: any;

  onMultiSelectChange($event: Event) {
    throw new Error('Method not implemented.');
  }

  title: any = { 'dashboard': 'Dashboard', 'all-tasks': 'In Progress Tasks', 'my': 'My Tasks', 'complete': 'Completed Tasks', 'pending-payment': 'Pending Payment', 'delivered': 'Delivered' };

  inProgressCount: any

  statusMap = new Map<string, string>([
    ['SU', 'Created'],
    ['IP', 'In Progress'],
    ['OH', 'On Hold'],
    ['PF', 'Pending Feedback'],
    ['IC', 'In Correction'],
    ['CO', 'Complete'],
    ['PP', 'Pending Payment'],
    ['NW', 'New Order']
  ]);

  feedbackMap = new Map<number, string>([
    [4, 'Approved'],
    [3, 'Optimized'],
    [2, 'Approved with Corrections'],
    [1, 'Rejected']
  ]);

  feedbackColorMap = new Map<number, string>([
    [1, 'lightgreen'],
    [2, 'lightblue'],
    [3, 'lightsalmon'],
    [4, 'orangered']
  ]);

  timeLeft: any;
  status: string = '';
  taskData: Task[] = [];
  filteredTaskData: Task[] = [];
  selectedTaskIds: number[] = [];
  procSummaryByTask: Map<number, string> = new Map();
  doctorList: any[] = [];
  designerList: any[] = [];

  fileCountsNew: any = {}
  fileCountsDesign: any = {}
  fileCountsScan: any = {}
  fileCountsTotal: any = {}

  commentCountsNew: any = {}
  commentCountsTotal: any = {}
  showMultiFiler: boolean = true;

  showModelNow: boolean = false;
  stepNumber: Number = 1

  constructor(private http: HttpClient, public dataService: DataService, private dialogService: DialogService, private route: ActivatedRoute, private dialog: MatDialog, private location: Location, private router: Router) { }
  downloadOrder(taskId: any) {
    this.dataService.updateProgressBarSubjectForSlider(true);
    this.dataService.get('/tasks/' + taskId + '/pdf/', { responseType: 'blob' }).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = taskId + 'order_form.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.dataService.updateProgressBarSubjectForSlider(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to download the file, Please try again.');
      }
    });

  }
isFromDetails: boolean = false;

@ViewChild(MatPaginator) paginator!: MatPaginator;
  ngOnInit() {
 
    const fromDetails = history.state?.fromDetails === true;

  // Three navigation sources require different state restoration:
  // fromCart → clear everything; fromDetails → restore page/filters; fresh load → reset
  this.route.queryParams.subscribe(params => {
  const fromCart = params['fromCart'] === 'true';

  if (fromCart) {

    // reset filters when coming from cart
    this.currentPage = 0;
    this.selectedStatuses = [];
    this.selectedOptions = [];

    sessionStorage.removeItem('selectedTaskFilters');
    this.dataService.setSelectedTaskFilters([]);

  } else if (fromDetails) {
    this.isFromDetails= true;

      // restore pagination
      this.currentPage = +params['page'] || 0;
      this.pageSize = +params['pageSize'] || 10;

      // restore status
      const statusParam = params['status'];
      this.selectedStatuses = statusParam ? statusParam.split(',') : [];

      // restore designer/doctor filters
      const storedFilters = sessionStorage.getItem('selectedTaskFilters');
      this.selectedOptions = storedFilters ? JSON.parse(storedFilters) : [];

      this.dataService.setSelectedTaskFilters(this.selectedOptions);
      

    } else {

      // user refreshed task list
      this.currentPage = 0;
      this.selectedStatuses = [];
      this.selectedOptions = [];

      sessionStorage.removeItem('selectedTaskFilters');
      this.dataService.setSelectedTaskFilters([]);

    }

    this.goToPage(this.currentPage);

    // clear router state so refresh won't reuse it
    window.history.replaceState({}, document.title);

  });

  this.dataService.trigger$.subscribe(status => {
    this.filterTriggerValue = status;
  });
    // Duplicate subscription — second one was added for dashboard trigger path; safe to consolidate in future
    this.dataService.trigger$.subscribe(status => {
      this.filterTriggerValue = status;
    });
    
    // this.getTasks(); 
    this.route.params.subscribe(params => {
      this.status = params['status'];
      this.dataService.updateTitle(this.title[this.status]);
      this.initData();
      
    });
  }

  initData() {
    // this.getProcedureDetails();
    this.getFileCountsFromBackend();
    // this.getCommentsCountsFromBackend();
    this.getTasks();
  }

  generateRandomId() {
    return Math.floor(Math.random() * 1000000000);
  }

  applyFilter(event: Event) {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.filteredTaskData = this.taskData.filter(item => {
      var stringToSearch = JSON.stringify(item) + JSON.stringify(this.procSummaryByTask.get(item.taskId));
      return stringToSearch.toLowerCase().includes(searchTerm.toLowerCase());
    });

    this.currentPage = 0;

  }
  filterDesigner($event: MatSelectChange): void {
    this.selectedDesigner = $event.value;

    if (this.selectedDesigner) {
      this.filteredTaskData = this.taskData.filter(task => task.nickName === this.selectedDesigner);
    } else {
      this.filteredTaskData = this.taskData;
    }
  }

  filterDoctor($event: MatSelectChange): void {
    this.selectedDoctor = $event.value;

    if (this.selectedDoctor) {
      this.filteredTaskData = this.taskData.filter(task => task.createBy === this.selectedDoctor);
    } else {
      this.filteredTaskData = this.taskData;
    }
  }

  getFilteredTask(selectedStatus: string[]) {
    this.dataService.updateProgressBarSubject(true);

    this.dataService.getDataAsList('/tasks/' + this.status).subscribe({
      next: (response) => {
        this.taskData = response;

        if (this.taskData.length == 0) {
          this.dataService.updateProgressBarSubject(false);
        }

        this.inProgressCount = this.taskData.length;

        this.filteredTaskData = this.taskData;
        this.filteredTaskData = this.filteredTaskData.filter(task => selectedStatus.includes(task.status));
         

        // For pending-payment, keep the progress bar active until PayPal script loads to avoid a flash of unstyled payment UI
        if (this.status != 'pending-payment') {
          this.dataService.updateProgressBarSubject(false);
        } else {
          this.createPaypalOrder();
          this.loadPayPalScript();
          const orderTotal = this.taskData.map(td => td.amount).reduce((a, b) => a + b, 0);
          this.paypalOrder = { id: this.generateRandomId(), purchase_units: [{ amount: { value: orderTotal.toFixed(2), currency_code: 'EUR' } }] };
        }

      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get In Progress Tasks, Please try again.');
      }
    });
  }


  fileDetailsScan: FileDetails[] = [];
  fileDetailsImages: FileDetails[] = [];
  // fileDetailsImagesContent: string[] = [];
  fileDetailsOrderForm: FileDetails[] = [];
  fileDetailsDesign: FileDetails[] = [];
  fileDetailsVisual: FileDetails[] = [];
  fileDetailsCorrectedDesign: FileDetails[] = [];
  fileDetailsCorrected3dVisualisation: FileDetails[] = [];
  fileDetails: FileDetails[] = [];
  comments: Comments[] = [];


  downloadProgress: Number = 0

  downloadProgressId: { id: number; situation: number }[] = [];

  taskId: number = 0;
  taskDetails: any;
  showSliderFile: MyBoolean = { value: false };
  showSliderComments: MyBoolean = { value: false };

  // Per-file download state machine: situation 1 = in-progress, 2 = done, 3 = error
  downloadFile(fileId: number, fileName: string) {
    this.dataService.updateProgressBarSubject(true);
    this.downloadProgress = 1
    let restData = this.downloadProgressId.filter(data => data.id !== fileId)
    restData.push({ "id": fileId, "situation": 1 })
    this.downloadProgressId = restData


    this.dataService.get('/tasks/' + this.taskId + '/files/' + fileId, { responseType: 'blob' }).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.dataService.updateProgressBarSubject(false);

        this.downloadProgress = 2

        let restData = this.downloadProgressId.filter(data => data.id !== fileId)
        restData.push({ "id": fileId, "situation": 2 })
        this.downloadProgressId = restData


      },
      error: (err) => {
        this.downloadProgress = 3
        let restData = this.downloadProgressId.filter(data => data.id !== fileId)
        restData.push({ "id": fileId, "situation": 3 })
        this.downloadProgressId = restData

        this.dialogService.handleError(err, 'Failed to download the file, Please try again.');
      }
    });
  }


  getFileDetails(taskId: Number) {
    this.taskId = taskId as number; // Set the taskId property
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/' + taskId + '/files').subscribe({
      next: (response: FileDetails[]) => {
        this.fileDetails = response;

        this.fileDetailsScan = [];
        this.fileDetailsDesign = [];
        this.fileDetailsVisual = [];
        this.fileDetailsImages = [];
        this.fileDetailsImagesContent = [];
        this.fileDetailsCorrectedDesign = [];
        this.fileDetailsCorrected3dVisualisation = [];

        response.forEach(file => {
          if (file.fileType == 'scan') {
            this.fileDetailsScan.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'design') {
            this.fileDetailsDesign.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'visual') {
            this.fileDetailsVisual.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'images') {
            this.fileDetailsImages.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
            this.populateImagesContent(file.fileId);
          } else if (file.fileType == 'correcteddesign') {
            this.fileDetailsCorrectedDesign.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'correctedvisual') {
            this.fileDetailsCorrected3dVisualisation.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } 
          
          // else {
          //   this.fileDetailsDesign.push(file);
          //   this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })

          // }
        });


        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Files for this Task, Please try again.');
      }
    });

    this.dataService.get('/tasks/' + taskId).subscribe({
      next: (response) => {
        this.taskDetails = response;
        this.orderDetailsNew = JSON.parse(response.jsonData);
        this.getComments(taskId);
        // this.getFileCountsFromBackend();
        // this.getCommentsCountsFromBackend();
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Task Details, Please try again.');
      }
    });
  }

  getComments(taskId: Number) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/' + taskId + '/comments').subscribe({
      next: (response) => {
        this.comments = response;
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Comments for this Task, Please try again.');
      }
    });
  }

  async populateImagesContent(fileId: number) {
    try {
      const response = await firstValueFrom(this.dataService.get('/tasks/' + this.taskId + '/files/' + fileId, { responseType: 'blob' }));
      this.fileDetailsImagesContent.push(URL.createObjectURL(new Blob([response], { type: 'application/octet-stream' })));
    } catch (err) {
      this.dialogService.handleError(err, 'Failed to get File Contents, Please try again.');
    }
  }


  checkCondition(id: number, situation: number): boolean {
    return this.downloadProgressId.some(item => item.id === id && item.situation === situation);
  }

  onStatusFilterChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedStatuses = Array.from(selectElement.selectedOptions).map(o => o.value);
    this.applyAllFilters();
  }
  

  statusOptions = [
     { value: 'NW', label: 'New Order'  },
    { value: 'IP', label: 'In Progress' },
    { value: 'PF', label: 'Pending Feedback' },
    // { value: 'In Revision', label: 'In Revision' },
    { value: 'CO', label: 'Complete' },
    // { value: 'Delayed', label: 'Delayed' },
    { value: 'CA', label: 'Cancelled' },
    // { value: 'Pending Payment', label: 'Pending Payment' }
  ];

  statusBadgeStyles: { [key: string]: { backgroundColor: string; color: string } } = {
    'NW': { backgroundColor: '#EDEDED', color: '#5C5C5C' },
    'IP': { backgroundColor: '#FFF8E0', color: '#B19700' },
    'PF': { backgroundColor: '#E5ECF6', color: '#0057B8' },
    'IC': { backgroundColor: '#F2F2F2', color: '#5C5C5C' },
    'CO': { backgroundColor: '#DFF5E5', color: '#1E824C' },
    // 'Delayed': { backgroundColor: '#FFF3E0', color: '#F57C00' },
    // 'NOTIFIED': { backgroundColor: '#FDECEA', color: '#D32F2F' },
    'DEFAULT': { backgroundColor: '#E0E0E0', color: '#333' }
  };

  getStatusBadgeStyle(status: string) {
    return this.statusBadgeStyles[status] || this.statusBadgeStyles['DEFAULT'];
  }


  feedbackTextFinal: string = '';
  cancelReason: string = '';
  feedbackId: string = '';
  taskStatus: string = '';

  rating = 0;
  hoveredRating = 0;
  stars = [1, 2, 3, 4, 5];

  rate(value: number) {
    this.rating = value;
  }

  hover(value: number) {
    this.hoveredRating = value;
  }
  feedbackSavedMessage: string = '';
showFeedbackSaved: boolean = false;


  submitFeedbackNow() {
    this.dataService.updateProgressBarSubject(true);
    var commentToSave = this.feedbackId == '1' ? this.cancelReason : this.feedbackTextFinal;
    this.dataService.put('/tasks/' + this.taskId + '/feedback', { feedbackId: this.feedbackId, comment: commentToSave, rating: this.rating }).subscribe({
      next: (response) => {
        this.dataService.updateProgressBarSubject(false);
        this.taskStatus = this.feedbackId == '2' ? 'IC' : 'CO';
        this.dialogService.openMessageDialog('Info', 'Saved the Feedback successfully.').subscribe(response => {
          // this.router.navigate(['/task-list/delivered']);
        }
        );
        this.dialogService.openMessageDialog(
          'Info',
          'Saved the Feedback successfully.'
        );
        // ✅ Show inline message
      this.feedbackSavedMessage = 'Saved the Feedback successfully.';
      this.showFeedbackSaved = true;

      // auto-hide after 2-3 seconds
      setTimeout(() => {
        this.showFeedbackSaved = false;
      }, 2500);

      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to save Feedback, Please try again.');
      }
    });
  }

  cancelOrder() {
    this.dataService.updateProgressBarSubject(true);
    var commentToSave = this.feedbackId == '1' ? this.cancelReason : this.feedbackTextFinal;
    
    this.dataService.put('/tasks/' + this.taskId + '/feedback', { feedbackId: this.feedbackId, comment: commentToSave, rating: this.rating }).subscribe({
      next: (response) => {
        this.taskStatus = this.feedbackId == '2' ? 'IC' : 'CO';
        var msg = this.feedbackId == '1' ? 'Task Cancelled successfully' : 'Saved the Feedback successfully.'
        this.dialogService.openMessageDialog('Info', msg).subscribe(response => {
          // this.router.navigate(['/task-list/delivered']);
          this.getTasks();
        }
        );

        this.stepNumber = 1
        this.showModelNow = false

        if(this.feedbackId == '1'){
          this.dataService.post('/common/notifications/' + this.taskId + '/CANCELED', {}).subscribe({})
        }
        
        this.dataService.updateProgressBarSubject(false);

      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to save Feedback, Please try again.');
      }
    });
  }


  openFeedbackModal(taskId: number, refNum: string) {
    this.dialog.open(FeedbackDialogComponent, { width: '60%', height: '80%', data: { taskId: taskId, refNum: refNum, feedbackMap: this.feedbackMap } }).afterClosed().subscribe(result => {
      if (result) {
        this.getTasks();
      }
    });
  }

  openCommentModal(taskId1: number, refNum1: string) {
    this.dialog.open(CommentsComponent, { maxWidth: '70vw', height: 'auto', data: { taskId: taskId1, refNum: refNum1 } }).afterClosed().subscribe(result => this.getCommentsCountsFromBackend());
  }

  completeTask(taskId: number, refNum: string) {
    this.dialog.open(ConfirmDialogComponent, { width: '25%', data: { title: 'Confirm Task Completion?', lines: ['Case / Patient: ' + refNum, 'Task Id: ' + taskId] } }).afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      this.dataService.updateProgressBarSubject(true);
      this.dataService.put('/tasks/' + taskId + '/complete', {}).subscribe({
        next: (response) => {
          this.getTasks();
          this.dataService.updateProgressBarSubject(false);
        },
        error: (err) => {
          this.dialogService.handleError(err, 'Failed to Complete task, Please try again.');
        }
      });
    });
  }

  claimTask(taskId: number, refNum: string) {
    this.dialog.open(ConfirmDialogComponent, { width: '25%', data: { title: 'Confirm Task Acceptance?', lines: ['Case / Patient: ' + refNum, 'Task Id: ' + taskId] } }).afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      this.dataService.updateProgressBarSubject(true);
      this.dataService.put('/tasks/' + taskId + '/claim', {}).subscribe({
        next: (response) => {
          this.taskData = this.taskData.filter(task => task.taskId !== taskId);
          this.filteredTaskData = this.taskData;
          this.dataService.updateProgressBarSubject(false);
        },
        error: (err) => {
          this.dialogService.handleError(err, 'Failed to Accept task, Please try again.');
        }
      });
    });
  }

  holdTask(taskId: number) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.put('/tasks/' + taskId + '/hold', {}).subscribe({
      next: (response) => {
        this.getTasks()
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to put Task on Hold, Please try again.');
      }
    });
  }

  deleteTask(taskId: number) {
    this.dialog.open(ConfirmDialogComponent, { width: '25%', data: { title: 'Confirm Task Deletion?', lines: ['Task Id: ' + taskId] } }).afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      this.dataService.updateProgressBarSubject(true);
      this.dataService.delete('/tasks/' + taskId).subscribe({
        next: (response) => {
          this.dataService.updateProgressBarSubject(false);
          this.dataService.updateCartCount();
          this.initData();
        },
        error: (err) => {
          this.dataService.updateProgressBarSubject(false);
          this.dialogService.handleError(err, 'Failed to remove item from cart, Please try again.');
        }
      });
    });
  }

  resumeTask(taskId: number) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.put('/tasks/' + taskId + '/resume', {}).subscribe({
      next: (response) => {
        this.getTasks()
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to Resume the Task, Please try again.');
      }
    });
  }

  openFilesModal(taskId1: number, refNum1: string) {
    this.dialog.open(FilesComponent, { width: '60%', height: '80%', data: { taskId: taskId1, refNum: refNum1 } }).afterClosed().subscribe(result => this.getFileCountsFromBackend());
  }

  combineToothNumbers(input: string[]): string {
    return this.dataService.combineToothNumbers(input.map(Number));
  }

  getFileCountsFromBackend() {
    this.dataService.updateProgressBarSubject(true);
    if (this.status == 'all-tasks') {
      // this.getCommentsCountsFromBackend();
      return;
    }

    this.dataService.getDataAsList('/tasks/files/' + this.status).subscribe({
      next: (response) => {
        this.fileCountsDesign = {}; this.fileCountsScan = {}; this.fileCountsNew = {}; this.fileCountsTotal = {};
        response.forEach(task => {
          this.fileCountsDesign[task.taskId] = task.designCount;
          this.fileCountsScan[task.taskId] = task.scanCount;
          this.fileCountsNew[task.taskId] = task.newCount;
          this.fileCountsTotal[task.taskId] = task.designCount + task.scanCount;
        });
        // this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get File Counts, Please try again.');
      }
    });
  }

  getCommentsCountsFromBackend() {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/comments/' + this.status).subscribe({
      next: (response) => {
        response.forEach(task => {
          this.commentCountsNew[task.taskId] = task.newCount;
          this.commentCountsTotal[task.taskId] = task.totalCount;
        });
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Comment Counts, Please try again.');
      }
    });
  }

  getProcedureDetails() {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/procs/' + this.status).subscribe({
      next: (response) => {
        response.forEach(task => {
          var summaryStr: string = Array.from(task.procedureDetailsList).map((proc: any) =>
            `(${proc.teethList.length} Unit${proc.teethList.length > 1 ? 's' : ''}) ${proc.procedureDesc.replaceAll('<hr>', '')}`
          ).join('<br>');
          this.procSummaryByTask.set(task.taskId, summaryStr);
        });
        // this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Task Rx Details, Please try again.');
      }
    });
  }
  // Whole hours left (0 if overdue)
  getHoursLeft(createdAt: string | Date, durationHours: number): number {
    const deadline = new Date(createdAt).getTime() + Number(durationHours) * 3_600_000;
    const hours = (deadline - Date.now()) / 3_600_000;
    return Math.max(0, Math.floor(hours));
  }

  getHourAndTimeTimeLeft(createdAt: string | Date, durationHours: number): string {
    const deadline = new Date(createdAt).getTime() + Number(durationHours) * 3_600_000;
    const diffMs = deadline - Date.now();

    if (diffMs <= 0) {
      return "0h 0m";
    }

    const totalMinutes = Math.floor(diffMs / 60_000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
  }
  


  getTasks(): void {
    this.dataService.updateProgressBarSubject(true);
  
    this.dataService
      .getDataAsList('/tasks/' + this.status)
      .pipe(
        finalize(() => {

          this.dataService.updateProgressBarSubject(false);
        })
      )
      .subscribe({
        next: (response) => {
          this.taskData = response || [];
  
          if (!this.taskData.length) {
            return;
          }
  

          this.inProgressCount = this.taskData.length;
  
          this.taskData.forEach(task => {
            task.timeLeftStr = this.getHourAndTimeTimeLeft(
              task.createTime,
              task.deliveryTime
            );
          });
  
          this.taskData.sort((a, b) => b.taskId - a.taskId);

          this.filteredTaskData = [...this.taskData];
        if (this.currentPage == null || this.currentPage < 0) {
          this.currentPage = 0;
        }
        this.applyAllFilters();
          this.updatePagination();

          const doctorMap = new Map<
            string,
            { doctorFirstName: string; doctorLastName: string; count: number }
          >();
  
          this.taskData.forEach(task => {
            if (!doctorMap.has(task.createBy)) {
              doctorMap.set(task.createBy, {
                doctorFirstName: task.doctorFirstName,
                doctorLastName: task.doctorLastName,
                count: 1
              });
            } else {
              doctorMap.get(task.createBy)!.count++;
            }
          });
  
          this.doctorList = Array.from(doctorMap.entries()).map(([id, doc]) => ({
            id,
            firstName: doc.doctorFirstName,
            lastName: doc.doctorLastName,
            count: doc.count
          }));

          const designerMap = new Map<string, { designerFirstName: string; count: number }>();
  
          this.taskData.forEach(task => {
            if (!designerMap.has(task.nickName)) {
              designerMap.set(task.nickName, {
                designerFirstName: task.nickName,
                count: 1
              });
            } else {
              designerMap.get(task.nickName)!.count++;
            }
          });
  
          this.designerList = Array.from(designerMap.entries()).map(([id, designer]) => ({
            id,
            firstName: designer.designerFirstName,
            count: designer.count
          }));
  
         
  
          // this.selectedPerson = this.dataService.selectedPerson;
          // this.selectedOptions = [...this.dataService.selectedOptions];
  
         // this.applyAllFilters();



          if (this.filterTriggerValue !== null) {
            setTimeout(() => {
              document.getElementById('id_' + this.filterTriggerValue)?.click();
              this.filterTriggerValue = null;
            }, 50);
          }

          if (this.status === 'pending-payment') {
            this.showMultiFiler = false;
            this.createPaypalOrder();
            this.loadPayPalScript();
  
            const orderTotal = this.taskData.reduce(
              (sum, td) => sum + (td.amount || 0),
              0
            );
  
            this.paypalOrder = {
              id: this.generateRandomId(),
              purchase_units: [{
                amount: {
                  value: orderTotal.toFixed(2),
                  currency_code: 'EUR'
                }
              }]
            };

//             this.selectedPerson = this.dataService.selectedPerson;
// this.selectedOptions = [...this.dataService.selectedOptions];

//this.applyAllFilters();

          }
        },
  
        error: (err) => {
          this.dialogService.handleError(
            err,
            'Failed to get In Progress Tasks, Please try again.'
          );
        }
      });
  }
  

  selectTask(taskId: number, isChecked: boolean) {
    const index = this.selectedTaskIds.indexOf(taskId);
    if (index === -1) {
      this.selectedTaskIds.push(taskId);
    } else {
      this.selectedTaskIds.splice(index, 1);
    }
  }



  toggleAllSelections(isChecked: boolean): void {
    if (isChecked) {
      this.filteredTaskData.forEach(task => {
        if (this.fileCountsTotal[task.taskId] && this.fileCountsTotal[task.taskId] !== 0) {
          this.selectedTaskIds.push(task.taskId);
        }
      });
    } else {
      this.selectedTaskIds.splice(0, this.selectedTaskIds.length);
    }
  }


  areAllSelected(): boolean {
    return this.filteredTaskData.every(task =>
      this.fileCountsTotal[task.taskId] &&
      this.selectedTaskIds.includes(task.taskId)
    );
  }

  someSelected(): boolean {
    return this.filteredTaskData.some(task =>
      this.fileCountsTotal[task.taskId] &&
      this.selectedTaskIds.includes(task.taskId)
    );
  }

  downloadSelectedTaskFiles() {
    if (this.selectedTaskIds.length == 0) {
      this.dialogService.openMessageDialog('Error', 'Select a Task to download files.');
    } else {
      const dialogData = {
        title: 'Select File Type',
        options: new Map<string, string>([['scan', 'Scan Files'], ['design', 'Design Files']])
      }

      this.dialog.open(OptionsDialogComponent, { data: dialogData, }).afterClosed()
        .subscribe(selectedOption => {
          if (selectedOption) {
            Array.from(this.selectedTaskIds).forEach(taskId => this.downloadAllFiles(taskId, selectedOption));
          } else {
            return;
          }
        });
    }
  }


  downloadAllFiles(taskId: number, selectedOption: string) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.get('/tasks/' + taskId + '/files/all?fileType=' + selectedOption, { responseType: 'blob' }).subscribe({
      next: (response) => {
        if (response.size == 0) {
          this.dialogService.openMessageDialog('Info', 'No ' + selectedOption + ' files to download for Task Id: ' + taskId);
        } else {
          const blob = new Blob([response], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = taskId + '.zip';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        }
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to download all files, Please try again.');
      }
    });
  }

  // File Upload Functionality Starts Here
  removeProgress(name: string) {
    delete this.progress[name]; // removes it from the progress grid
  }

  removeFileByName(fileName: string) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.delete('/tasks/' + this.taskId + '/files?file-name=' + fileName.replace(/[^a-zA-Z0-9.]/g, '_')).subscribe({
      next: (response) => {
        var index = this.fileDetailsScan.findIndex((file) => file.fileName === fileName);
        if (index > -1) {
          this.fileDetailsScan.splice(index, 1);
        }
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to Remove File, Please try again.');
      }
    });
  }

  private formatDuration(sec: number): string {
    if (!isFinite(sec) || sec < 0) return '';
    if (sec < 1) return '1 second left';
    if (sec < 60) return `${Math.max(1, Math.round(sec))} seconds left`;
    const m = Math.floor(sec / 60);
    const s = Math.round(sec % 60);
    return s > 0 ? `${m}m ${s}s left` : `${m}m left`;
  }


  private updateEta(entry: FileProgress, total: number) {
    // Exponential moving average for speed
    const now = performance.now();
    if (entry.lastTs) {
      const dt = (now - entry.lastTs) / 1000;
      const dbytes = Math.max(0, entry.loaded - entry.lastLoaded);
      const inst = dbytes / Math.max(0.001, dt);
      const alpha = 0.25; // smoothing (0..1)
      entry.speedBps = entry.speedBps ? (alpha * inst + (1 - alpha) * entry.speedBps) : inst;
    }
    entry.lastTs = now;
    entry.lastLoaded = entry.loaded;

    if (total && entry.speedBps > 0) {
      const remain = Math.max(0, total - entry.loaded);
      entry.etaSeconds = remain / entry.speedBps;
      entry.etaLabel = this.formatDuration(entry.etaSeconds);
    } else {
      entry.etaSeconds = undefined;
      entry.etaLabel = 'calculating…';
    }
  }


  private formatBytes(b: number): string {
    if (!isFinite(b)) return '';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let i = 0; let n = b;
    while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
    return `${n.toFixed(i ? 2 : 0)}${units[i]}`;
  }

  progress: Record<string, FileProgress> = {};

  private sanitizeName(name: string) {
    return name.replace(/[^a-zA-Z0-9.]/g, '_');
  }


  private stopTrickle(name: string) {
    const entry = this.progress[name];
    if (entry?.intervalId) { clearInterval(entry.intervalId); entry.intervalId = undefined; }
  }


  private startTrickle(name: string, to = 99, step = 1, ms = 500) {
    const entry = this.progress[name];
    if (!entry) return;
    this.stopTrickle(name);
    entry.intervalId = setInterval(() => {
      const e = this.progress[name];
      if (!e || e.state === 'done' || e.state === 'error') return this.stopTrickle(name);
      if (e.percent < to) e.percent += step;
    }, ms);
  } 

  // Add 'allowMode' parameter, defaulting to 'confirm'
  public uploadWithProgress(file: File, allowMode: string = 'confirm') {
    const apiBase = environment.apiUrl;
  
    const url = `${apiBase}/tasks/${this.taskId}/files?allow=${allowMode}`;
  
    const form = new FormData();
    form.append('file', file);
  
    const safe = this.sanitizeName(file.name);
    const headers = new HttpHeaders().set('X-Digital-FileName', safe);
  
   
    if (allowMode === 'confirm') {
      this.progress[safe] = {
        percent: 0,
        state: 'uploading',
        size: file.size,
        sizeLabel: this.formatBytes(file.size),
        loaded: 0,
        lastLoaded: 0,
        lastTs: 0,
        speedBps: 0
      };
    } else {
      
      const e = this.progress[safe];
      if (e) e.state = 'uploading';
    }
  
    const req = new HttpRequest('POST', url, form, {
      reportProgress: true,
      responseType: 'text',
      headers
    });
  
    this.http.request(req).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress && (event as any).total) {
          const { loaded, total } = event as any;
          const e = this.progress[safe];
          if (!e) return;
  
          e.loaded = loaded;
          const realPct = Math.round((loaded / total) * 100);
          e.percent = Math.min(realPct, 92);
          this.updateEta(e, total);
  
          if (loaded >= total && e.state !== 'waiting') {
            e.state = 'waiting';
            this.startTrickle(safe, 99, 1, 400);
          }
        } else if (event.type === HttpEventType.Response) {
          const e = this.progress[safe];
          const res = JSON.parse(event.body as string);
      
          if (res.fileName === "You are about to upload file with same content") {
              this.stopTrickle(safe);
              
              this.dialogService.openConfirmDialog(
                'File already exists:', // Header
                `File name: ${this.orignialFileNameForUpload}. Do you want to upload another copy?`
              ).subscribe((confirmed: boolean) => {
                  if (confirmed) {
                     
                      this.uploadWithProgress(file, 'allow');
                  } else {
                     
                      this.removeProgress(safe);
                      // this.removeFileByName(file.name); 
                  }
              });
              return; 
          }
          if (res.fileName === "Duplicate file content detected.") {
            this.stopTrickle(safe);
            
            this.dialogService.openMessageDialog(
                'Duplicate Content Found', 
                'This file content already exists.'
            ).subscribe((confirmed: boolean) => {
                if (confirmed) {
                
                    this.uploadWithProgress(file, 'allow');
                } else {
                  
                    this.removeProgress(safe);
                    this.removeFileByName(file.name); 
                }
            });
            return; 
        }
          
          
          if (e) {
            this.stopTrickle(safe);
            e.percent = 100;
            e.state = 'done';
            e.etaLabel = 'Completed';
        
            
            if (res.fileName && res.fileName !== safe) {
          
              this.progress[res.fileName] = { ...e };
             
              delete this.progress[safe];
            }
          }
        
          this.fileDetailsScan.push({
            fileId: 0,
            fileType: '',
            fileName: res.fileName, // Store the corrected name in your database array
            fileSize: file.size
          });
        }
      },
      error: (err) => {
        this.dialogService.openMessageDialog('Error', err?.error?.message || 'Upload failed.');
        const e = this.progress[safe];
        if (e) { this.stopTrickle(safe); e.state = 'error'; }
      }
    });
  }

  @HostListener('drop', ['$event'])
  onDrop(e: DragEvent) {
    e.preventDefault(); e.stopPropagation();
    Array.from(e.dataTransfer?.files ?? []).forEach(f => this.uploadWithProgress(f));
    e.dataTransfer?.clearData();
  }

  orignialFileNameForUpload: string = '';

  addFileDetails(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    const MAX_SIZE_BYTES = 200 * 1024 * 1024;
    files.forEach((file) => {
      if (file.size > MAX_SIZE_BYTES) {
        const sizeStr = this.formatBytes(file.size);
        this.dialogService.openMessageDialog(
          'File Too Large', 
          `The file "${file.name}" is ${sizeStr}. Please upload files smaller than 200MB.`
        );
        return; // Skip this specific file
      }
      let displayName = file.name;
   
  
      let counter = 1;
  this.orignialFileNameForUpload = file.name; // Store the original file name for later use
      const nameExists = () => this.fileDetailsScan.some(f => f.fileName === displayName);
      while (nameExists()) {
        const dotIndex = file.name.lastIndexOf('.');
        const baseName = dotIndex !== -1 ? file.name.substring(0, dotIndex) : file.name;
        const extension = dotIndex !== -1 ? file.name.substring(dotIndex) : '';
        displayName = `${baseName} (${counter})${extension}`;
        counter++;
      }
  
     
      this.fileDetailsScan.push({
        fileName: displayName, 
        fileSize: file.size,
        fileType: file.type,
        fileId: 0
      } as any);
  
      
      const blob = file.slice(0, file.size, file.type);
      const renamedFile = new File([blob], displayName, { type: file.type });
      this.uploadWithProgress(renamedFile, 'confirm');
    });
  
    input.value = '';
  }

  loadPayPalScript() {
    const script = document.createElement('script');
    script.src = 'https://www.paypal.com/sdk/js?client-id=AbBeaL5iOV9LSkn_LmH1az1AfZXoNEAUgAHxNTomYnOP16AG_fy0GwnkDJvvvrrNBqohzCzHzD7nxKWg&components=buttons&currency=EUR';
    script.onload = () => {
      this.renderPayPalButton();
    };
    document.body.appendChild(script);
  }

  paypalOrder: any = {};

  createPaypalOrder() {
    this.clearAllStatuses();
    this.downloadandSearch = false;
    this.dataService.updateProgressBarSubject(true);
    this.dataService.post('/payments/paypal/orders', {}).subscribe({
      next: (response) => {
        this.paypalOrder = response;
        this.dataService.updateProgressBarSubject(false);
      },
      // error: (err) => {
      //   // this.dialogService.handleError(err, 'Failed to create order, Please try again.').subscribe(result => this.location.back());
      // }
    });
  }

  edit(taskId: number) {
    this.router.navigate(['/create-task-demo'], { queryParams: { taskId: taskId } });
  }

  navigateToOrderDetails(showModel: boolean) {
    this.showModelNow = showModel
  }

navigateToOrderDetailsURL(taskId: number, page: number, pageSize: number): void {

  const statusParam = this.selectedStatuses.join(',');

  // save filters
  this.dataService.setSelectedTaskFilters(this.selectedOptions);
  sessionStorage.setItem('selectedTaskFilters', JSON.stringify(this.selectedOptions));

  this.router.navigate(['/task-details'], {
    queryParams: {
      taskId: taskId,
      page: page,
      pageSize: pageSize,
      status: statusParam
    }
  });
}
 navigateToOrderDetailsPage(taskId: number, page: number, pageSize: number): void {
  if (this.dataService.role === 'doctor') {
     const statusParam = this.selectedStatuses.join(',');

  // save filters
  this.dataService.setSelectedTaskFilters(this.selectedOptions);
  sessionStorage.setItem('selectedTaskFilters', JSON.stringify(this.selectedOptions));

 this.router.navigate(['/task-details'], {
  queryParams: {
    taskId: taskId,
    page: page,
    pageSize: pageSize,
    status: statusParam
  },
  state: { fromDetails: true }   // 👈 ADD THIS
});
  }
}

  changeStep(stepNumber: Number) {
    this.stepNumber = stepNumber
  }



  closeModal(showModel: boolean) {
    this.showModelNow = showModel
  }

  shadowFeedbackModel(taskId: number) {
    this.dialog.open(FeedbackDialogComponent, { width: '60%', height: '80%', data: { taskId: taskId, feedbackMap: this.feedbackMap } }).afterClosed().subscribe(result => {
      if (result) {
        this.getTasks();
      }
    });
  }

  completePayment() {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.post('/payments/paypal/orders/' + this.paypalOrder.id + '/capture?amount=' + this.paypalOrder.purchase_units[0].amount.value, this.taskData.map(td => td.taskId)).subscribe({
      next: (response) => {
        this.dataService.updateProgressBarSubject(false);
        this.router.navigate(['/payment-success'], { queryParams: { id: response.id } });
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to complete order, Please try again.').subscribe(result => window.location.href = '#/task-list/pending-payment');
      }
    });
  }

  bypassPayment() {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.post('/payments/paypal/orders/' + this.paypalOrder.id + '/bypass-payment?amount=' + this.paypalOrder.purchase_units[0].amount.value, this.taskData.map(td => td.taskId)).subscribe({
      next: (response) => {
        this.dataService.updateProgressBarSubject(false);
        this.dataService.updateCartCount();
        this.router.navigate(['/payment-success'], { queryParams: { id: this.paypalOrder.id } });
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to complete order, Please try again.').subscribe(result => window.location.href = '#/task-list/pending-payment');
      }
    });
  }

  renderPayPalButton() {
    window.paypal.Buttons({
      createOrder: (data: any, actions: any) => {
        return this.paypalOrder.id; // the order is created on page load.
      },
      onApprove: (data: any, actions: any) => {
        // this.dataService.updateProgressBarSubject(true);
        return this.dataService.post('/payments/paypal/orders/' + this.paypalOrder.id + '/capture', this.taskData.map(td => td.taskId)).subscribe({
          next: (response) => {
            // this.dataService.updateProgressBarSubject(false);
            this.dataService.updateCartCount();
            this.router.navigate(['/payment-success'], { queryParams: { id: response.id } });
            // this.dialogService.openMessageDialog('Success', 'Payment Successful, Order Reference Number: ' + response.id).subscribe(result => {
            //   this.dataService.updateCartCount();
            //   window.location.href = '#/dashboard';
            // });
          },
          error: (err) => {
            this.dialogService.handleError(err, 'Failed to complete order, Please try again.').subscribe(result => window.location.href = '#/task-list/pending-payment');
          }
        });

      },
      onError: (err: any) => {
      },
      style: {
        layout: 'horizontal',
        color: 'gold',
        shape: 'rect',
        label: 'pay',
        tagline: false,
        height: 38
      }
    }).render('#paypal-button-container');
  }


  selectedStatuses: string[] = [];

  pageSize = 10;
  currentPage = 0;
  paginatedData: any[] = [];
  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePagination(); 
  }
  onPageSizeChange() {
  this.currentPage = 0;
  this.updatePagination();
}

  onPersonFilterChange(selectedValue: string | null): void {
    this.selectedPerson = selectedValue;
    this.dataService.selectedPerson = selectedValue;
    this.applyAllFilters();
  }
  

visiblePages: number[] = [];
showDots = false;
totalPageCount = 0;

updatePagination() {

  const start = this.currentPage * this.pageSize;
  const end = start + this.pageSize;

  this.paginatedData = this.filteredTaskData.slice(start, end);

  this.totalPageCount = Math.ceil(this.filteredTaskData.length / this.pageSize);

  this.generatePages();
}

generatePages(){

  const maxVisible = 3;

  if(this.totalPageCount <= maxVisible){
    this.visiblePages = Array.from({length:this.totalPageCount},(_,i)=>i);
    this.showDots = false;
  }else{

    const start = Math.floor(this.currentPage/maxVisible)*maxVisible;

    this.visiblePages = Array.from({length:maxVisible},(_,i)=>start+i)
    .filter(p=>p < this.totalPageCount);

    this.showDots = start + maxVisible < this.totalPageCount;

  }
}

goToPage(page:number){

  this.currentPage = page;
  this.updatePagination();

}

nextPage(){

  if(this.currentPage < this.totalPageCount-1){
    this.currentPage++;
    this.updatePagination();
  }

}

prevPage(){
  if(this.currentPage > 0){
    this.currentPage--;
    this.updatePagination();
  }
}


  compareNull = (a: any, b: any): boolean => a === b;
  private applyPersonFilter(): void {
    if (!this.selectedPerson) return;
  
    this.filteredTaskData = this.filteredTaskData.filter(task =>
      this.dataService.role === 'doctor'
        ? task.assignTo === this.selectedPerson
        : task.createBy === this.selectedPerson
    );
  }
  

  onPersonBootstrapFilterChange(event: Event): void {
    this.selectedPerson = (event.target as HTMLSelectElement).value || null;
    this.dataService.selectedPerson = this.selectedPerson;
    this.applyAllFilters(); // IMMEDIATE filtering
  }
  
  
  onCheckboxFilterChange(): void {
    this.dataService.selectedOptions = [...this.selectedOptions];
    this.applyAllFilters();
  }
  

  toggleStatus(status: string): void {
    if (this.selectedStatuses.includes(status)) {
      this.selectedStatuses = this.selectedStatuses.filter(s => s !== status);
    } else {
      this.selectedStatuses.push(status);
    }
    this.currentPage=0;
    this.applyAllFilters(); // IMMEDIATE filtering
  }
  
  
  clearAllStatuses(): void {
    this.selectedStatuses = [];
    this.applyAllFilters();
  }
  

  toggleOption(option: string) {
    const idx = this.selectedOptions.indexOf(option);
    if (idx > -1) {      this.selectedOptions.splice(idx, 1);
    } else {
      this.selectedOptions.push(option);
    }
     this.applyAllFilters();
  }

  clearAll() {
    this.selectedOptions = [];
    this.clearAllStatuses();
  }

  public applyAllFilters(): void {
    let data = [...this.taskData]; // start fresh every time
    

    if (this.selectedStatuses.length) {
      data = data.filter(task =>
        this.selectedStatuses.includes(task.status)
      );
    }
  

    if (this.selectedPerson) {
      data = data.filter(task =>
        this.dataService.role === 'doctor'
          ? task.assignTo === this.selectedPerson
          : task.createBy === this.selectedPerson
      );
    }
    if (this.selectedOptions.length) {
      if(this.dataService.role === 'doctor'){
      data = data.filter(task =>
        this.selectedOptions.includes(task.nickName)
      );
    }else{
      data =data.filter(task=>this.selectedOptions.includes(task.createBy))
    }
    }
  
    this.filteredTaskData = data;
    if (!this.isFromDetails) {
    this.currentPage = 0;
  }
    this.updatePagination();
  }
  
  
 showFeedbackMessage: boolean = false;
feedbackMessage: string = '';
showButtons: boolean = true;  
isRequestCorrection=false;
ShowRequestFeedback: boolean = false;
feedbackMessageRequest: string = '';

  requestCorrection(taskId: any) {
   
  if (this.isRequestCorrection) return; 
  this.isRequestCorrection = true;
  this.submitFeedback(taskId);
  
  }
  

  submitFeedback(taskId: any) {
    this.dataService.put('/tasks/' + taskId + '/feedback', { comment: this.feedbackText ,feedbackId:this.feedbackId}).subscribe({
      next: (response) => {
          this.dataService.updateProgressBarSubject(false);
        // this.dialogService.openMessageDialog('Info', 'Saved the Feedback successfully.').subscribe(response => {
        // this.closeModal(false);
       if(this.isRequestCorrection){
            this.feedbackMessageRequest ='Feedback Saved successfully!';

        this.ShowRequestFeedback = true;

        }else{
       this.feedbackMessage =
          this.feedbackId === '1'
            ? 'Task Cancelled successfully'
            : 'Feedback Saved successfully!';

        this.showFeedbackMessage = true;

        this.showReviewOverlay = false;
        this.showButtons = false;}
        //this.closeModal(false);
      },
      error: (err) => {
       // this.dialogService.handleError(err, 'Failed to save Feedback, Please try again.');
        //this.closeModal(false);
         this.dataService.updateProgressBarSubject(false);

        // Show red error message
        this.feedbackMessage = 'Failed to save feedback, please try again.';
        this.showFeedbackMessage = true;
          this.showFeedbackMessage = false;
          
        // Also log or handle the error internally if needed
      }
    });

  }


  openDelievrOrderModal(taskId: any, refNum: any, taskStatus: any) {
    this.dialog.open(FilesDialogComponent, { width: '60%', height: '80%', data: { taskId: taskId, refNum: refNum, taskStatus: taskStatus } }).afterClosed()
      .subscribe(result => {
        this.fileDetailsScan = result.fileDetailsScan;
        this.fileDetailsImages = result.fileDetailsImages;
        this.fileDetailsImagesContent = result.fileDetailsImagesContent;
      });
  }
  


  // private applyAllFilters(): void {
  //   let data = [...this.taskData];
  
  //
  //   if (this.selectedStatuses.length) {
  //     data = data.filter(task =>
  //       this.selectedStatuses.includes(task.status)
  //     );
  //   }
  
  //
  //   if (this.selectedPerson) {
  //     data = data.filter(task =>
  //       this.dataService.role === 'doctor'
  //         ? task.assignTo === this.selectedPerson
  //         : task.createBy === this.selectedPerson
  //     );
  //   }
  
  //
  //   if (this.selectedOptions.length) {
  //     data = data.filter(task =>
  //       this.selectedOptions.includes(task.nickName)
  //     );
  //   }
  
  //   this.filteredTaskData = data;
  
  //
  //   this.currentPage = 0;
  //   this.updatePagination();
  // }
  
getPersonNameById(id: string): string {
  const list = this.dataService.role === 'doctor' ? this.designerList : this.doctorList;
  const person = list.find(p => p.id === id);
  return person ? person.firstName : 'Unknown';
}


removeSelectedOption(id: string) {
  this.selectedOptions = this.selectedOptions.filter(x => x !== id);
  this.applyAllFilters();
}

 showReviewOverlay = false;

onApprove() {
    this.feedbackId = '3';
    this.showReviewOverlay = true;   
    this.showModelNow=true;
  }


isApproved(): boolean {
  return String(this.feedbackId) === '3';
}

hasCorrected3d(): boolean {
  const hasData = !!(
    this.fileDetailsCorrected3dVisualisation &&
    this.fileDetailsCorrected3dVisualisation.length > 0
  );


  return hasData;
}


loadTask(task: any) {
  this.feedbackId = task.feedbackId; 
}



}
